/* eslint-disable @typescript-eslint/no-explicit-any */
import dot from "../../assets/images/Dots_Background.svg";

import team1 from "../../assets/images/Dr_Ashok_Omray.png";
import team2 from "../../assets/images/Dr_Sagar_Vichare.png";
import team3 from "../../assets/images/Ms_Devika_Damania.png";
import team4 from "../../assets/images/Dr_Ashok_Mohanty.png";
import team5 from "../../assets/images/Ms_Ashlesha_Kambli.png";
import team6 from "../../assets/images/Miss_Nidhi_Vichare.png";
import team7 from "../../assets/images/Mrs_Mohini_R_Patil.png";
import team8 from "../../assets/images/Mrs_Akshada_Vichare.png";
import team9 from "../../assets/images/Mrs_Manjiri_Harmalkar.png";
import Carousel from "../Carousel";

const teamMembers = [
  { id: 1, name: "Dr. Ashok Omray", role: "Director", image: team1 },
  { id: 2, name: "Dr. Sagar Vichare", role: "Director", image: team2 },
  { id: 3, name: "Ms. Devika Damania", role: "Director", image: team3 },
  { id: 4, name: "Dr. Ashok Mohanty", role: "Advisory board member", image: team4 },
  { id: 5, name: "Ms. Ashlesha Kambli", role: "Advisory board member", image: team5 },
  { id: 6, name: "Ms. Nidhi Vichare", role: "Management Trainee", image: team6 },
  { id: 7, name: "Ms. Mohini R. Patil", role: "Advisory board member", image: team7 },
  { id: 8, name: "Ms. Akshada Vichare", role: "Advisory board member", image: team8 },
  { id: 9, name: "Mrs. Manjiri Harmalkar", role: "Quality Specialist", image: team9 },
];

const TeamMemberCard = ({ member }:{ member:any }) => (
  <div className="flex flex-col items-center text-center rounded p-1 h-44 md:h-64">
    <img
      src={member.image}
      alt={member.name}
      className="w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 lg:w-40 lg:h-40 object-contain mt-10"
    />
    <h3 className="text-center text-xs sm:text-base font-regular text-[#ffffff]">
      {member.name}
    </h3>
    <p className="text-center text-md sm:text-sm font-bold text-[#ffffff] px-2 md:px-4">
      {member.role}
    </p>
  </div>
);

export default function Team() {
  const teamCards = teamMembers.map((member) => (
    <TeamMemberCard key={member.id} member={member} />
  ));

  return (
    <div className="-mb-44 sm:-mb-42 md:-mb-54 lg:-mb-54">
      <Carousel
        title="Our Team"
        itemsPerPageConfig={{
          mobile: 2,
          tablet: 4,
          desktop: 4,
          large: 6
        }}
        showArrows={true}
        showDots={true}
        gap="gap-1"
        className="py-5 pb-12"
        backgroundImage={dot}
      >
        {teamCards}
      </Carousel>
    </div>
  );
};